import Vue from 'vue'

import cloneDeep from 'lodash/cloneDeep'

// function replaceAll(str, find, replace) {
//   return str.replace(new RegExp(find, "g"), replace);
// }
// const showNotification = (msg, type) => {
//   Vue.toasted.show(replaceAll(msg + '', 'Error:', ''), {
//     keepOnHover: true,
//     closeOnSwipe: false,
//     theme: 'bubble',
//     duration: 3000,
//     type: type || 'info',
//     position: 'top-right',
//   })
// }

export default function makeCrudModule({
  normalizeRelations = (x) => x,
  resolveRelations = (x) => x,
  service,
  idKey,
} = {}) {
  return {
    // Actions for `create`, `update` and `delete` omitted for brevity.
    actions: {
      all: async ({ commit }) => {
        // It is not strictly necessary to pass a service,
        // but if none was passed, no data can be loaded.

        if (!service) throw new Error('No service specified!')
        commit('setLoading', true)

        const payload = {
          Airport: 'LEJ',
        }

        service
          .list(payload)
          .then((response) => {
            const items = response.data.Results[0]
            commit('clear')
            items.forEach((item) => {
              // Noramlize nested data and swap the related objects
              // in the API response with an ID reference.
              commit('add', normalizeRelations(item))
            })
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      },
      load: async ({ commit }, id) => {
        if (!service) throw new Error('No service specified!')
        const response = await service.find(id)

        const item = response.data.Results[0][0]

        commit('add', normalizeRelations(item))
      },
      post: async ({ commit }, payload) => {
        if (!service) throw new Error('No service specified!')
        commit('setLoading', true)

        await service
          .post(payload)
          .then((response) => {
            if (response.status === 201) {
              // const item = response.data;
              // commit("add", { item: normalizeRelations(item)});
            }
          })
          .catch((error) => {
            // showNotification(error.response.data.Message, 'error')
            throw new Error(error.response.data.Message)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      },
      patch: async ({ commit }, payload) => {
        if (!service) throw new Error('No service specified!')

        const serverData = cloneDeep(payload)

        commit('setLoading', true)
        await service
          .patch(serverData)
          .then((response) => {
            if (response.status === 200) {
              // const item = response.data;
              // commit("add", { item: normalizeRelations(item)});
            }
          })
          .catch((error) => {
            throw new Error(error.response.data.error.message)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      },
      delete: async ({ commit }, id) => {
        if (!service) throw new Error('No service specified!')
        commit('setLoading', true)
        await service.delete(id)
        commit('remove', id)
        commit('setLoading', false)
      },
      setSelected: ({ commit }, payload) => {
        commit('setSelected', payload)
      },
      setSelectedGridItems: ({ commit }, payload) => {
        commit('setSelectedGridItems', payload)
      },
      setCurrentPage: ({ commit }, page) => {
        commit('setCurrentPage', page)
      },
      setItemCount: ({ commit }, count) => {
        commit('setItemCount', count)
      },
      setItemsPerPage: ({ commit }, payload) => {
        commit('setItemsPerPage', payload)
      },
      updateItem: ({ commit }, payload) => {
        commit('localUpdate', payload)
      },
    },
    getters: {
      // Return a single item with the given id.
      find: (state, getters, rootState) => (id) => {
        // Swap ID referenes with the resolved objects.

        // Swap ID referenes with the resolved objects.
        const item = resolveRelations(state.byId[id])
        // If this data has AirlineGroupId, lookup Airline data
        if (item && item.AirlineGroupId) {
          item.AirlineGroup = rootState.AirlineGroup.byId[item.AirlineGroupId]
        }

        if (
          item &&
          Object.keys(item)[0] !== 'LocationAreaId' &&
          item.LocationAreaId
        ) {
          item.Location = rootState.LocationAreas.byId[item.LocationAreaId]
        }

        return item
      },
      // Return a list of items in the order of `allIds`.
      list: (state, getters) => {
        return state.allIds.map((id) => getters.find(id))
      },
      selected: (state) => {
        return state.selected
      },
      selectedGridItems: (state) => {
        return state.selectedGridItems
      },
      loading: (state) => state.loading,
      getCurrentPage: (state) => state.currentPage,
      getItemCount: (state) => state.itemCount,
      getItemsPerPage: (state) => state.itemsPerPage,
      getDirtyIds: (state) => state.dirtyIds,
    },
    mutations: {
      clear: (state) => {
        Vue.set(state, 'byId', {})
        Vue.set(state, 'allIds', [])
      },
      add: (state, item) => {
        Vue.set(state.byId, item[idKey], item)
        if (state.allIds.includes(item[idKey])) return
        state.allIds.push(item[idKey])
      },
      localUpdate: (state, item) => {
        Vue.set(state.byId, item.Id, item)

        if (!state.allIds.includes(item.Id)) {
          state.allIds.push(item.Id)
        }
        if (!state.dirtyIds.includes(item.Id)) {
          state.dirtyIds.push(item.Id)
        }
      },
      remove: (state, id) => {
        window.console.log(state, id)
      },
      setSelected: (state, payload) => {
        Vue.set(state, 'selected', payload)
      },
      setSelectedGridItems: (state, payload) => {
        Vue.set(state, 'selectedGridItems', payload)
      },
      setLoading: (state, payload) => {
        Vue.set(state, 'loading', payload)
      },
      setCurrentPage: (state, page) => {
        Vue.set(state, 'currentPage', page)
      },
      setItemCount: (state, count) => {
        Vue.set(state, 'itemCount', count)
      },
      setItemsPerPage: (state, payload) => {
        Vue.set(state, 'itemsPerPage', payload)
      },
    },
    namespaced: true,
    state: {
      byId: {},
      allIds: [],

      loading: false,
      selected: null,
      selectedGridItems: [],

      dirtyIds: [],
      itemCount: null,
      itemsPerPage: 40,
      currentPage: 1,
    },
  }
}
